import getPhotoUrl from '@alltrails/core/utils/getPhotoUrl';
import getPhotoUrlFromId from '@alltrails/core/utils/getPhotoUrlFromId';

// returns an array of photos that can be processed by the lightbox
function urlReformatPhotos(photos): { id: number; imgUrl: string }[] {
  let imageHash;

  return photos.map(photo => {
    const { id, photo_hash, photoHash } = photo;
    imageHash = photo_hash || photoHash;

    // TODO: Add support for fallback when direct CDN link doesn't work right https://github.com/alltrails/alltrails/pull/10243
    const url =
      id && imageHash
        ? getPhotoUrl({ isOptimized: true, photo: { id, photoHash: imageHash }, size: '2048x2048' })
        : getPhotoUrlFromId({ id, size: '2048x2048' });
    return { id, imgUrl: url };
  });
}

export default urlReformatPhotos;
